import TextFormatOutlined from '@mui/icons-material/TextFormatOutlined';
import { s } from '../../format/schema';
import { defineFieldType, noSettings } from '../card';
import { RichTextInput } from './FillInput';
import { visibleLength, visibleText } from './visible-text';

export const richText = defineFieldType({
  type: 'richText',
  name: 'Rich text',
  valueKind: 'text',
  settings: noSettings,
  defaults: {},
  canResize: () => false,
  value: s.string(),
  emptyValue: '',
  hasDefaultValue: true,
  validations: ['required', 'range'],
  operators: ['isFilled', 'isEmpty', 'contains', 'notContains'],
  palette: [{ name: 'Rich text', tooltip: 'Bold, italic, lists and links', group: 'Text', icon: TextFormatOutlined }],
  isEmpty: value => visibleText(value) === '',
  quantity: visibleLength,
  comparable: value => visibleText(value).toLowerCase(),
  comparableTyped: text => text.trim().toLowerCase(),
  FillInput: RichTextInput,
  fillLabel: () => 'label',
  reportsLeaving: true,
});
